// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab
} from '@mui/material'
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const [searchParams] = useSearchParams();
    const currentTab = searchParams.get('tab_gr');

    // ** State
    const [value, setValue] = useState<string>(currentTab ?? '0')
    const [mode, setMode] = useState<string>(currentTab ?? '0')

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [listData, setListData] = useState<any[]>([])

    useEffect(() => {
        getData(mode)
    }, [])

    const navigate = useNavigate();

    const getData = (mode: any) => {
        setMode(mode)
        setListData([])

        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        let url = apiUrl.apiUrl + '/mm/gudang-kain/list-gr'

        axios
            .get(url, {
                params: {
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir,
                    mode: mode,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const handleChangeTab = (event: SyntheticEvent, newValue: string) => {
        navigate(`?tab=9&tab_gr=${newValue}`);
        setValue(newValue)
    }


    const ActionButtons = ({ row, onNavigate }: {
        row: any;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row.id)
            },
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'center' }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const ActionButtonsAdd = ({ row, onNavigate }: {
        row: any;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Buat GR",
                icon: "mdi:plus-circle",
                color: "primary",
                onClick: () => onNavigate(row.po_id)
            },
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'center' }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onNavigate={(id) => navigate(`/mm/gudang/kain/detail/${id}?tab=9&tab_gr=${currentTab}`)}
                />
            ),
        },
    ];

    const actionDataAdd = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtonsAdd
                    row={row}
                    onNavigate={(id) => navigate(`/mm/gudang/kain/add/${id}?tab=9&tab_gr=${currentTab}`)}
                />
            ),
        },
    ];

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <Divider />
                <CardContent>
                    <Grid
                        container
                        sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                        spacing={5}
                    >
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>
                                <TextField
                                    label='Tanggal Awal'
                                    type='date'
                                    onChange={(e) => setTglAwal(e.target.value)}
                                    value={tglAwal}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>

                                <TextField
                                    label='Tanggal Akhir'
                                    type='date'
                                    onChange={(e) => setTglAkhir(e.target.value)}
                                    value={tglAkhir}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <FormControl fullWidth>
                                <Button
                                    variant='contained'
                                    sx={{ mt: 1 }}
                                    startIcon={<Icon icon='mdi:magnify' />}
                                    onClick={() => getData(mode)}
                                >
                                    Cari Data
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <TabContext value={value}>
                        <TabList
                            sx={{ ml: -5, mt: 2 }}
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTab}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='0' onClick={() => getData('0')} label='DAFTAR GR' />
                            <Tab value='3' onClick={() => getData('3')} label='OUTSTANDING PO' />
                            <Tab value='1' onClick={() => getData('1')} label='OTO WH' />
                            <Tab value='2' onClick={() => getData('2')} label='OTO PURCHASING' />
                        </TabList>
                        <TabPanel value='0'>
                            <MsiDatagrid array={listData} actions={actionData} />
                        </TabPanel>
                        <TabPanel value='3'>
                            <MsiDatagrid array={listData} actions={actionDataAdd} hiddenColumns={['pbpo_d_id', 'po_id', 'item_id']} />
                        </TabPanel>
                        <TabPanel value='1'>
                            <MsiDatagrid array={listData} actions={actionData} />
                        </TabPanel>
                        <TabPanel value='2'>
                            <MsiDatagrid array={listData} actions={actionData} />
                        </TabPanel>
                    </TabContext>
                </CardContent>
            </Grid>
        </Grid>
    )
}
